import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {getFavoriteCinemas, getFavoriteCinemasSeeMore, removeCinemaFromFavorite} from '../../../SHARED/actions/profile.actions'
import { API_URL } from '../../config/apiEndpoints';

class FavCinemas extends Component {

    componentWillMount(){
        this.props.getFavoriteCinemas();
    }

    getTotalItems = () => {
        return this.props.favoriteCinemas.pager  ? this.props.favoriteCinemas.pager.total_items : 0;
    }

    getSeeMoreCondition = () => {  
        if(this.props.favoriteCinemas.rows && this.props.favoriteCinemas.rows.length > 0){
            return (
                <div className="col see-more nopadding">
                    <span onClick={this.seeMore}>{this.props.favoriteCinemas.rows.length !== this.props.favoriteCinemas.pager.total_items ? "Vezi mai multe..." : "" }</span>
                </div>
            );
        }
    }

    seeMore = () => {
        this.props.getFavoriteCinemasSeeMore(this.props.favoriteCinemas.pager.current_page + 1);
    }

    removeCinemaFromFavorite = (cinemaId, pager) => {
        this.props.removeCinemaFromFavorite({cinemaId, pager});
    }

    getContent = () => {
        if(this.props.favoriteCinemas.rows)
        return this.props.favoriteCinemas.rows.map((card, i) => {
            return <div className="item-cinema row nopadding" key={i}>
                <div className="col-lg-3">
                    <Link to={`/cinematografe`} >
                        <img src={card.cinema_image !== "" ? API_URL + card.cinema_image : ""} alt="Cinematograf"/>
                    </Link>
                </div>
                <div className="col-lg-9 cinema-dt">
                    <span className="notif-delete" onClick={() => this.removeCinemaFromFavorite(card.favorite_uuid, this.props.favoriteCinemas.pager)} />     
                    <div className="row no-gutters">
                        <div className="col-lg-8">
                            <Link to={`/cinematografe`} className="white-text">
                                <p className="cinema-name float-left">{card.cinema_name}</p>
                            </Link>
                        </div>
                    </div>     
                    <div className="row no-gutters">
                        <div className="all-details col-xl-11">
                            <span>Adresa: {card.cinema_address_street}, {card.cinema_address_locality}</span>
                            <span>Număr săli: {card.cinema_nr_of_rooms}</span>
                            <span>Telefon: {card.cinema_telephone}</span>
                            <span>Email: {card.cinema_email}</span>
                            <span>{card.cinema_website}</span>
                        </div>
                        <div className="col-xl-1">
                            {/*<p className="float-right">
                                <Link to={"/"}>Vezi harta</Link>
                            </p>*/}
                        </div>
                    </div>
                </div>
            </div>
        });
    };
    render() {
        return (
            <Fragment> 
                    <div className="profile-item-header ">
                        <span className="icon-cinema float-left" />
                        <span className="profile-notif-summary">Cinematografe favorite ({this.getTotalItems()})</span>
                    </div>
                    <div className="fav-cinemas">
                        { this.getContent() }
                    </div>
                    { this.getSeeMoreCondition() }
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    favoriteCinemas: state.profile.favoriteCinemas,
});
export default connect(mapStateToProps, {getFavoriteCinemas, getFavoriteCinemasSeeMore, removeCinemaFromFavorite})(FavCinemas);





// WEBPACK FOOTER //
// ./src/SHARED/components/favcinemas/favcinemas.component.js